import { render } from "./stockAdjustmentForm.vue?vue&type=template&id=bb3c4af8&scoped=true"
import script from "./stockAdjustmentForm.vue?vue&type=script&lang=js"
export * from "./stockAdjustmentForm.vue?vue&type=script&lang=js"

import "./stockAdjustmentForm.vue?vue&type=style&index=0&id=bb3c4af8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3c4af8"]])

export default __exports__